<template>
  <v-dialog v-model="open" width="800"  scrollable persistent>
    <v-card :loading="loading">
  
      <v-card-title class="mb-5">
        <slot name="title"></slot>
      </v-card-title>

      <template v-if="!loading">

        <v-card-subtitle class="pb-2">
          <slot name="subtitle"></slot>
        </v-card-subtitle>

        <v-card-text>        
          <slot name="body"></slot>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>

          <slot name="actions"></slot>
        </v-card-actions>

      </template>

    </v-card>
  </v-dialog>
</template>

<script>
  export default {
    props: {
      open: {
        type: Boolean
      },
      loading: {
        type: Boolean
      }
    }
  }
</script>

<style lang="scss" scoped>
</style>